import { Box, Button, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

/**
 * Shown when a page-level query fails.
 * Replaces the broken crash that happens when .data is accessed on undefined.
 *
 * Props:
 *   message  - Error message from the ApolloError
 *   onRetry  - Optional callback for the "Try again" button.
 *              Defaults to refetching all provided queries.
 */
const PageError = ({ message, onRetry }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "50vh",
        textAlign: "center",
        px: 2,
        mt: { xs: 8, sm: 10 },
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 52, color: "error.main", mb: 2 }} />
      <Typography variant="h6" sx={{ color: "white", mb: 1 }}>
        Failed to load data
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: 3, maxWidth: 480 }}
      >
        {message || "Something went wrong while loading this page."}
      </Typography>
      {onRetry && (
        <Button variant="contained" onClick={onRetry}>
          Try again
        </Button>
      )}
    </Box>
  );
};

export default PageError;
